import { match, P } from 'ts-pattern';

import { PropertyTypeEnum, QueryBuilderField } from '../../shared/properties';
import { Property } from '../../shared/properties';
import { buildFieldPath } from './build-field-path';

/**
 * Get values for a property based on its type
 * @param property The property definition
 * @returns Array of values or undefined
 */
const getPropertyValues = (property: Property<PropertyTypeEnum>) => {
  return match(property)
    .with(
      {
        type: P.union(PropertyTypeEnum.choices),
        settings: P.not(P.nullish),
      },
      (propertyWithSettings) => {
        return 'options' in propertyWithSettings.settings
          ? propertyWithSettings.settings.options?.map((option) => ({
              label: option.label,
              value: option.key,
            }))
          : undefined;
      },
    )
    .otherwise(() => undefined);
};

export const propertyToQueryBuilderField = ({
  context,
  property,
  selectedPrefix,
}: {
  context: string;
  property: Property<PropertyTypeEnum>;
  selectedPrefix?: string;
}): QueryBuilderField & { property: Property<PropertyTypeEnum> } => ({
  name: buildFieldPath(property, context),
  label: property.label,
  type: property.type,
  values: getPropertyValues(property),
  selectedPrefix,
  property,
});
